module.exports = __webpack_public_path__ + "img/toplogo.cea055d7.png";